import { render } from "./Farmer.vue?vue&type=template&id=a86a57e6&ts=true"
import script from "./Farmer.vue?vue&type=script&lang=ts"
export * from "./Farmer.vue?vue&type=script&lang=ts"

import exportComponent from "/vercel/path1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__